import { render, staticRenderFns } from "./OrderPage.vue?vue&type=template&id=4be307f4"
import script from "./OrderPage.vue?vue&type=script&lang=ts"
export * from "./OrderPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports